import type { Endpoint, Route, Request, RequestArgs } from '../types.no-deps'

export const route: Route = { method: 'GET', pattern: '/api/guides/promoteReportInitialValues' }

type Params = never
type Body = never
type Query = { reportId: number }
type Output = { reportTitle: string; linkedProcedures: number[]; linkedUnits: number[] }

export type GetPromoteReportInitialValuesEndpoint = Endpoint<Params, Body, Query, Output>

export const getPromoteReportInitialValuesRequest = (
    request: Request,
    args: RequestArgs<GetPromoteReportInitialValuesEndpoint>
) => request<GetPromoteReportInitialValuesEndpoint>(route, args)
